module.exports = __webpack_public_path__ + "static/img/img_gy_e_e.da606872.png";